import { TranslationMap } from '@trimble-gcs/i18n-types';

export function localFilePickerTranslations() {
  return {
    browsePrefix: {
      text: $localize`:@@import.dialog.picker.local.browsePrefix:Drag .las, .laz or .e57 files here or`,
      desc:
        'Inline text appearing before the browse anchor tag. ' +
        'The text informs the user that files can be dragged and dropped onto the component.',
    },
    browse: {
      text: $localize`:@@import.dialog.picker.local.browse:browse`,
      desc:
        'Inline anchor tag text placed between browsePrefix and browseSuffix. ' +
        "The anchor opens the browser's local file picker dialog.",
    },
    browseSuffix: {
      text: $localize`:@@import.dialog.picker.local.browseSuffix:to upload.`,
      desc:
        'Inline text appearing after the browse anchor tag. ' +
        'The text informs the user that files can be dragged and dropped onto the component.',
    },
  } satisfies TranslationMap;
}
